import { NavLink, ThemeIcon, useComputedColorScheme, type NavLinkProps } from "@mantine/core";
import { createLink } from "@tanstack/react-router";
import { type RefObject } from "react";

import { type NavigationItem } from "@/components/Navbar/useNavigationElements";
import { SYSTEM_COLORS } from "@/configs/colorScheme";
import { useIsMobile } from "@/hooks/useIsMobile";

import styles from "@/components/Navbar/NavbarListItem.module.css";

interface CustomNavLinkProps extends NavLinkProps {
  ref?: RefObject<HTMLAnchorElement>;
}

const CustomNavLinkComponent = ({ ref, ...props }: CustomNavLinkProps) => {
  return <NavLink ref={ref} {...props} />;
};

const CustomNavLink = createLink(CustomNavLinkComponent);

interface Props {
  onClose?: () => void;
  navigationItem: NavigationItem;
}
const NavbarListItem = ({ navigationItem, onClose }: Props) => {
  const { isTablet } = useIsMobile();
  const colorScheme = useComputedColorScheme();
  const isDarkTheme = colorScheme === "dark";

  return (
    <CustomNavLink
      {...navigationItem.to}
      label={navigationItem.title}
      leftSection={
        <ThemeIcon size="sm" autoContrast variant="subtle">
          {navigationItem.icon}
        </ThemeIcon>
      }
      autoContrast
      variant={isDarkTheme ? "light" : "filled"}
      color={SYSTEM_COLORS.secondary}
      className={isTablet ? styles["custom-nav-link-mobile"] : styles["custom-nav-link"]}
      onClick={onClose}
    />
  );
};

export default NavbarListItem;
